import React from 'react'
import { IconProps } from '../../../common/types'

const DocumentsIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22 10.688v5c0 5-2 7-7 7H9c-5 0-7-2-7-7v-6c0-5 2-7 7-7h5"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18 10.688c-3 0-4-1-4-4v-4l8 8zM7 13.688h6M7 17.688h4"
      ></path>
    </svg>
  )
}

export default DocumentsIcon
